var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { substituteParams, useAPI } from '../../../state';
var ORG_FINANCIALS_API = '/api/orgconfig/financials';
var ORG_FINANCIALS_PROVIDER_RATES_API = '/api/orgconfig/financials/provider-rates';
var ORG_AVAILABLE_CURRENCIES_API = '/api/orgconfig/financials/available-currencies';
var LOCATION_FINANCIALS_API = '/api/orgconfig/locations/{locationId}/financials';
var COPY_FROM_API = '/api/orgconfig/locations/{locationId}/financials/copy-from';
var FINANCIALS_STATUS_API = '/api/orgconfig/locations/financials/status';
export var useOrgFinancialsAPI = function (configVersionId) {
    return useAPI("".concat(ORG_FINANCIALS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigFinancials-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useOrgFinancialsProviderRatesAPI = function (configVersionId) {
    return useAPI("".concat(ORG_FINANCIALS_PROVIDER_RATES_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigFinancialsProviderRates-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useAvailableCurrenciesAPI = function (base, configVersionId) {
    var normalizedBase = (base !== null && base !== void 0 ? base : '').trim().toUpperCase();
    var query = configVersionId ? '?base={base}&configVersionId={configVersionId}' : '?base={base}';
    return useAPI("".concat(ORG_AVAILABLE_CURRENCIES_API).concat(query), { base: normalizedBase || 'USD', configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigAvailableCurrencies-".concat(normalizedBase || 'none', "-").concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export function saveOrgFinancials(configVersionId, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = configVersionId ? "".concat(ORG_FINANCIALS_API, "?configVersionId=").concat(configVersionId) : ORG_FINANCIALS_API;
                    return [4 /*yield*/, axios.put(url, payload, { withCredentials: true })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export var useLocationFinancialsAPI = function (locationId) {
    return useAPI(substituteParams(LOCATION_FINANCIALS_API, { locationId: locationId !== null && locationId !== void 0 ? locationId : 0 }), { locationId: locationId !== null && locationId !== void 0 ? locationId : 0 }, 'GET', { key: locationId == null ? 'locationFinancials-none' : "locationFinancials-".concat(locationId) });
};
export function saveLocationFinancials(locationId, payload) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post(substituteParams(LOCATION_FINANCIALS_API, { locationId: locationId }), payload, { withCredentials: true })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export var useCopyFinancialsFromAPI = function (locationId) {
    return useAPI(substituteParams(COPY_FROM_API, { locationId: locationId }), {}, 'POST', {
        key: "financialsCopyFrom-".concat(locationId),
    });
};
export var useFinancialsStatusAPI = function (configVersionId) {
    return useAPI("".concat(FINANCIALS_STATUS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "financialsStatus-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
